<template>
    <div class="home-page">
        <!-- 上导航 -->
        <top-navigation 
            ref="nav"
            @select="_menuLeafSelHandler"
            @default="_setDefaultTag"
        ></top-navigation>

        <!-- tag系统 -->
        <tag-frame 
            ref="tag"
            style="top: 56px;"
            @shift="tagShiftHandler"
        ></tag-frame>
    </div>
</template>

<script>
import TagFrame from './components/tag-frame/index';
import TopNavigation from './components/top-navigation/index';

export default {
    components: {
        TagFrame,
        TopNavigation
    },
    data() {
        return {
            submenuExplain: false,
            versionAccessTime:''
        };
    },
    created() {
        // 记录新系统人数
        var that = this;
        // 获取信息
        that.$store.dispatch('views/queryUserInfo');
        that.versionAccessTime = setTimeout(function () {
            that.$post(`${that.getGetters('mngUrl')}/v2/system/statistics/versionAccess.json`, {
                versionNum: 'v2',
            }, function (data, res) {
                
            })
        }, 180000);
    },
    beforeDestroy() {
        // 清除定时器
        console.log(this.versionAccessTime)
        clearTimeout(this.versionAccessTime)
    },
    methods: {
        // 导航项点击方法
        _menuLeafSelHandler(item) {
            if (item.targetblank === '1') {
                window.open(item.url);
                return;
            }

            this.$refs.tag.pushTag({
                title: item.text,
                src: item.url,
                topparent: 'common-tag',
                id: item.id,
                type: item.type || 'href'
            });
        },
        // 设置不可关闭的默认tag
        _setDefaultTag(item) {
            this.$refs.tag.pushTag({
                title: item.text,
                src: item.url,
                topparent: item.pid,
                id: item.id,
                type: 'href',
                noclose: true,
            });

            this.tagShiftHandler(item);
        },
        // 外部调用，tag切换时同步展示所属导航
        tagShiftHandler(target) {
            this.$refs.nav.setActive(target.id, target.topparent);
        },
    },
};
</script>

<style lang="scss" scoped>
    .home-page{
        width: 100%;
        height: 100%;
        overflow-x: auto;
        overflow-y: hidden;
    }
</style>